import React from 'react';
import BaseExerciseForm from 'modules/exercises/components/BaseExerciseForm';

import { MultipleChoiceExerciseInput } from '../../types/form';
import { MultipleChoiceExercise } from '../../types';

import MultipleChoiceQuestionsForm from '../MultipleChoiceQuestionsForm';

import { useMultipleChoiceExercisesForm } from '../../hooks';

interface MultipleChoiceExerciseFormProps {
  onSubmit: (input: MultipleChoiceExerciseInput) => void;
  submitting: boolean;
  submitError?: string;

  defaultIncorrectOptionType: 'negative' | 'neutral';
  defaultNumberOfOptions: number;
  exercise?: MultipleChoiceExercise;
  exercisesCount?: number;
}

const MultipleChoiceExerciseForm = (props: MultipleChoiceExerciseFormProps) => {
  const { onSubmit, submitting, exercise, defaultIncorrectOptionType, defaultNumberOfOptions, exercisesCount = 0 } = props;

  const { useFormProps, allOptionTypes, getNextOption, getNextQuestion, canAddMoreOptions, initialQuestionNumber, onChangeInitialQuestionNumber } =
    useMultipleChoiceExercisesForm({
      exerciseIndex: exercisesCount,
      exercise,
      defaultNumberOfOptions,
      defaultIncorrectOptionType,
    });

  return (
    <BaseExerciseForm onSubmit={onSubmit} useFormProps={useFormProps} submitting={submitting}>
      <MultipleChoiceQuestionsForm
        initialQuestionNumber={initialQuestionNumber}
        onChangeInitialQuestionNumber={onChangeInitialQuestionNumber}
        defaultOptionType={defaultIncorrectOptionType}
        allOptionTypes={allOptionTypes}
        getNextQuestion={getNextQuestion}
        getNextOption={getNextOption}
        canAddMoreOptions={canAddMoreOptions}
      />
    </BaseExerciseForm>
  );
};

export default MultipleChoiceExerciseForm;
